import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ChangeRequestApiService from '../../../../api/ChangeRequestApiService';
import ChangeRequestLayout from '../../../../components/postSecondary/ChangeRequestLayout';
import ChangeRequestAdditionalDetailsForm from '../../../../components/forms/postSecondary/ChangeRequestAdditionalDetailsForm';
import Routes from '../../../../config/Routes';
import ChangeRequestStatusType from '../../../../consts/ChangeRequestStatusType';
import * as GetBaseChangeRequestDetailsHandler from '../../../../handlerModels/GetBaseChangeRequestDetailsHandler';
import ChangeRequestDTO from '../../../../models/ChangeRequestDTO';
import UserSecurity from '../../../../models/UserSecurity';
import BaseFormState from '../../../../redux/bases/BaseFormState';
import { StateStoreModel } from '../../../../redux/state/StateStoreModel';
import Guid from '../../../../utils/Guid';
import HistoryUtil from '../../../../utils/HistoryUtil';
import ParameterUtil from '../../../../utils/ParameterUtil';

interface CourseModificationChangeRequestStep3PageState extends BaseFormState {
  changeRequestId: string;
  changeRequest: ChangeRequestDTO;
}

interface CourseModificationChangeRequestStep3PageProps {
  currentUser: UserSecurity | null;
}

class CourseModificationChangeRequestStep3Page extends React.Component<CourseModificationChangeRequestStep3PageProps & RouteComponentProps<RouteObject>, CourseModificationChangeRequestStep3PageState> {
  constructor(props: CourseModificationChangeRequestStep3PageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      changeRequestId: Guid.Empty(),
      changeRequest: ChangeRequestDTO.create(),
    };
  }

  componentDidMount() {
    const id = ParameterUtil.getPathPart(this.props.match, 'id');
    if (id !== Guid.Empty() && this.state.changeRequestId != id) {
      this.setState({ changeRequestId: id });
      this.fetchData(id);
    }
  }

  private fetchData = (id: string) => {
    this.setState({ loading: true });

    const loaders = [];

    if (id !== Guid.Empty()) {
      loaders.push(this.loadChangeRequest(id));
    }

    Promise.all(loaders).then(() => {
      this.setState({ loading: false });
    });
  }

  private loadChangeRequest = (id: string) => {
    return ChangeRequestApiService.getBaseChangeRequestDetails(id)
      .then((results: GetBaseChangeRequestDetailsHandler.Result) => {
        if (results) {
          this.setState({
            changeRequest: results.changeRequest ?? ChangeRequestDTO.create(),
          });
        }
      }).catch(() => {
        this.setState({ error: true, message: 'Could not load change request.' });
      });
  }

  goToPreviousStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_COURSE_MODIFICATION_CHANGE_REQUEST_ENTRY_2, { id: this.state.changeRequestId }, {}))
  }

  goToNextStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_COURSE_MODIFICATION_CHANGE_REQUEST_ENTRY_REVIEW, { id: this.state.changeRequestId }, {}))
  }

  render() {
    return (
      <Content >
        <ChangeRequestLayout
          changeRequest={this.state.changeRequest ?? ChangeRequestDTO.create()}
          stepNumber={2}
          currentUser={this.props.currentUser ?? {} as UserSecurity}>
          <Card title="Additional Information" >
            <ChangeRequestAdditionalDetailsForm
              changeRequest={this.state.changeRequest}
              onPrevious={this.goToPreviousStep}
              onSubmit={this.goToNextStep}
              loading={this.state.loading} />
          </Card>
        </ChangeRequestLayout>
      </Content >
    );
  }

  showComments = () => {
    return this.state.changeRequest?.statusTypeId == ChangeRequestStatusType.ATTENTIONREQUIRED ?? false;
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    currentUser: state.UserSession.Value,
  };
}

export default withRouter(connect(mapStateToProps)(CourseModificationChangeRequestStep3Page));